import React, { useEffect, useState } from "react";
import { BaseApi } from "../base.api";
import {
    Button,
    Col,
    Row,
    Select,
    Table,
    Tag,
    Modal,
    Form,
    Spin,
    Input,
  } from "antd";
  import { Link, useNavigate } from "react-router-dom";

  // Define the type for a Company
  interface Translation {
    id: number;
    key: string;
    value: string;
    language: string;
  }
  interface CategoryOption {
    value: string;
    label: string;
  }

  const Translations: React.FC = () => {
    const [allTranslations, setAllTranslations] = useState<Translation[]>([]);
    const [propTranslation, setPropTranslation] = useState<Translation[]>([]);
    const [translations, setTranslations] = useState<Translation[]>([]);
    const [category, setCategory] = useState<CategoryOption[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [searchText, setSearchText] = useState<string>("");
    const [subsType, setSubsType] = useState<string>("");
    const [selLang, setSelLang] = useState<string>(() => {
      return localStorage.getItem("selectedLang") || "az";
    });
    useEffect(() => {
      loadTranslations();
    }, [selLang]);


    useEffect(() => {
      applyFilters();
    }, [searchText, subsType, allTranslations]);
 
    const loadTranslations = async () => {
      try {
        console.log("afjhasjfh");

        setLoading(true);
        const response = await new BaseApi().fetchData(
          `common-service/v1/translations/${selLang}/admin`
        );
        if (response?.data.data) {
          setTranslations(response?.data?.data);
          setAllTranslations(response.data.data);
          setPropTranslation(response.data.data);
          processCategories(response.data.data);
        }
        setLoading(false);
      } catch (error: any) {
        alert(error.message);
        setLoading(false);
      }
    };

    const columns = [
      {
        title: "Key",
        key: "key",
        dataIndex: "key",
        ellipsis: true,
      },
      {
        title: "Value",
        dataIndex: "value",
        key: "value",
        ellipsis: true,
      },
      {
        title: "Action",
        key: "subscription",
        render: (_: any, record: any) => (
          <div style={{ display: "flex", gap: "30px" }}>
            <Button
              onClick={(e) => {
                navigate("/main/translations/update_translation", {
                  state: { key: record.key },
                });
                e.stopPropagation();
              }}
            >
              Edit
            </Button>
            <Button
              onClick={(e) => {
                handleDelete(record.key);
                e.stopPropagation();
              }}
            >
              Delete
            </Button>
          </div>
        ),
      },
    ];
    const navigate = useNavigate();
    const handleRowClick = (record: any) => {
      navigate(`/main/translations/detail/${record.key}`);
    };

    const handleDelete = async (key: any) => {
      try {
        await new BaseApi().deleteData(
          `/common-service/v1/translations/by-key/${key}`
        );
        setTranslations(translations.filter((item: any) => item.key !== key));
      } catch (error: any) {
        alert(error.message);
      }
    };
    const applyFilters = () => {
      let filtered = [...allTranslations];
      if (subsType) {
        filtered = filtered.filter((item) => {
          const splitKey = item.key.split(".");
          return splitKey[0] === subsType;
        });
      }
    
      if (searchText) {
        const escapedVal = searchText.replace(/[.*+?^=!:${}()|\[\]\/\\]/g, "\\$&");
        const regex = new RegExp(escapedVal, "i");
        filtered = filtered.filter((item) => regex.test(item.key) || regex.test(item.value));
      }
      setTranslations(filtered);
    };
    const handleSearch = (val: string) => {
      setSearchText(val);
    };
    const changeCategory = (val: string) => {
      setSubsType(val);
    };
    

    const onPlanChange = async (lang: any) => {
      setSelLang(lang);
      localStorage.setItem("selectedLang", lang);
    }; 


    const processCategories = (translations: Translation[]) => {
      const keys = translations.map((item) => item.key);
      const uniqueCategories = Array.from(
        new Set(
          keys
            .map((key) => {
              const splitKey = key.split(".");
              return splitKey[0] && splitKey[0].trim();
            })
            .filter(Boolean)
        )
      );

      const options = uniqueCategories.map((category) => ({
        value: category,
        label: category,
      }));

      setCategory(options);
    };

  return (
    <div>
      <h1>Translations</h1>
      <Row style={{ marginBottom: "20px" }}>
        <Col xs={12} lg={6}>
          <Input
            placeholder="Write to search.."
            value={searchText}
            onChange={(e) => handleSearch(e.target.value)}
          />
        </Col>
        <Col xs={12} lg={3}>
          <Select
            style={{ width: "100%" }}
            onChange={onPlanChange}
            placeholder="Select language"
            value={selLang}
          >
            <Select.Option value="az">Azerbaijani</Select.Option>
            <Select.Option value="en">English</Select.Option>
            <Select.Option value="ru">Russian</Select.Option>
            <Select.Option value="tr">Turkish</Select.Option>
            <Select.Option value="pl">Poland</Select.Option>
            <Select.Option value="kz">Qazax</Select.Option>
          </Select>
        </Col>
        <Col xs={12} lg={3}>
          <Select
            showSearch
            style={{ width: 200, position: "sticky" }}
            placeholder="Select to type"
            value={subsType}
            onChange={changeCategory}
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
            options={category}
            allowClear
          ></Select>
        </Col>
        <Col span={8} offset={4}>
          <Link
            to="/main/translations/add_translation"
            state={{ data: propTranslation }}
          >
            <Button>Add Translation</Button>
          </Link>
        </Col>
      </Row>

      <Table
        dataSource={translations}
        columns={columns}
        rowKey="_id"
        loading={loading}
        onRow={(record) => ({
          onClick: () => handleRowClick(record),
        })}
      />
    </div>
  );
};

export default Translations;
